.receipt-settings {
  margin: 12px 0;

  &--text {
    font-size: 16px;
    font-weight: 700;
    line-height: 130%;
    margin: 0;
  }
}
